import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const GENERICMODAL_LEGACY_FIELD_ORDER = [
  
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  genericModalDescriptor: _generatedGenericModalDescriptor,
  genericModalModalDefinition,
  genericModalDashboardLayout,
  genericModalConfig,
  genericModalResolveConfig,
  genericModalProperties,
} = doodModalConfig(
  {
    name: "Generic modal",
    componentType: 'GenericModalComponent',
    category: 'modal',
    description: "Generic modal.",
    keywords: [],
    isContentModal: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'content',
        name: "pages.blocks.generic-modal.content.label",
        accept: 'explicitOnly',
        // `(?:Component)?` so legacy `Modal.*Block` and CB2 `*Component` types both match.
        allowedTypes: ["Modal.*Block(?:Component)?", "TextBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        "label": "Couleur de fond"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["background_color", "content"],
          },
        ],
      },
    ],
  })
);

export function genericModalDescriptor(): IBlockDescriptor;
export function genericModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function genericModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedGenericModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedGenericModalDescriptor, genericModalProperties, fieldOrder);
}

export {
  genericModalModalDefinition,
  genericModalDashboardLayout,
  genericModalProperties,
  genericModalConfig,
  genericModalResolveConfig,
};

export type GenericModalConfig = typeof genericModalConfig;
